export default "__VITE_ASSET__CFGg12V1__"